import { isNotUndefined } from '~/ZenOne-StoryBook/helpers/types'
import {
  PRICE_CLIENT_PRACTICE_VALUE,
  PRICE_RETAIL_VALUE,
  PRICE_ZEN_VALUE,
} from '~/ZenOne-StoryBook/components/Distributor/Admin/DistributorWizard/DistributorWizardSettingsForm/helper'
import { STATUS_DISCONTINUED } from '~/helpers/productDistributor'

export default {
  props: {
    item: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    isConnected() {
      const isConnected = this.item?.isConnected
      return isNotUndefined(isConnected) ? !!isConnected : false
    },
    stockLevel() {
      const stockLevel = this.item?.stockLevel
      return isNotUndefined(stockLevel) ? stockLevel : 0
    },
    showBackorderedLabel() {
      return this.isBackordered && !this.isDiscontinued
    },
    isBackordered() {
      return this.stockLevel === 0
    },
    isDiscontinued() {
      return this.item?.productDistributorStatus === STATUS_DISCONTINUED
    },
    priceType() {
      const priceType = this?.item?.priceType
      return isNotUndefined(priceType) ? priceType : ''
    },
    isZenPriceType() {
      const { priceType = '' } = this
      return priceType === PRICE_ZEN_VALUE
    },
    isRetailPriceType() {
      const { priceType = '' } = this
      return priceType === PRICE_RETAIL_VALUE
    },
    isClientPriceType() {
      const { priceType = '' } = this
      return priceType === PRICE_CLIENT_PRACTICE_VALUE
    },
    price() {
      let {
        item: { price = null },
      } = this
      if (!this.isProductTypeManufacturer)
        price = price?.actualPrice?.price
          ? price.actualPrice.price.toString()
          : null
      return price !== null ? price : 'N/A'
    },
    isPriceAvailable() {
      return this.priceValue !== 'N/A'
    },
    priceValue() {
      let { price = '' } = this
      if (!price || price === '' || price === '0') {
        price = 'N/A'
      }
      return price
    },
  },
}
